<div  *ngIf="message" [ngClass]="{ 'alert': message, 'alert-success': message.type === 'success', 'alert-danger': message.type === 'error' }">{{message.text}}
	<a class="close" (click)="alertClose()">&times;</a>
</div>